export default __webpack_public_path__ + "static/media/home-interior-design-slider-img03.2e195da3.jpg";